'use client';

import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import styled from 'styled-components';

import type { SheetDraggableProps } from '../types';
import { useSheetContext } from './context';

const SheetContent = forwardRef<any, SheetDraggableProps>(
  ({ children, disableDrag = false, ...rest }, ref) => {
    const { dragProps } = useSheetContext();

    return (
      <Content {...rest} ref={ref} className="react-modal-sheet-content" {...(disableDrag ? {} : dragProps)}>
        {children}
      </Content>
    );
  },
);

const Content = styled(motion.div)`
  flex: 1;
  overflow: auto;
  position: relative;
`;

export default SheetContent;
